<template>
	<div v-show="!autoSettings">
		<label>
			<span class="l_title">Тип примеров</span>
			<Select2 v-model="params.type" :options="[{id: 'multi', text: 'Умножение'}, {id: 'divisi', text: 'Деление'}]" :settings="{multiple: false,minimumResultsForSearch: -1}" />
			<!--<Select2 v-else v-model="params.type" :options="[{id: 'multi', text: 'Умножение'}]" :settings="{multiple: false,minimumResultsForSearch: -1}" />-->
		</label>

		<label v-if="!is_homework">
			<span class="l_title">Количество примеров: </span>
			<div class="plm">
				<div class="plm__button plm__button--minus" @click="addQnt('-', 'qnt')"></div>
				<input type="number" min="3" max="999999" :readonly="role == 'teacher' ? false : true" v-model="params.qnt">
				<div class="plm__button plm__button--plus" @click="addQnt('+', 'qnt')"></div>
			</div>
		</label>
		<div class="razd"></div>
		<!--- НАСТРОЙКИ УМНОЖЕНИЯ --->
		<div v-if="params.type === 'multi'">
			<h6 class="l_title">Первый множитель</h6>
			<label>
				<span class="l_title l_title--sm">Количество цифр: </span>
				<div class="plm">
					<div class="plm__button plm__button--minus" @click="addQnt('-', 'first', 'digits')"></div>
					<input type="number" min="1" max="8" :readonly="role == 'teacher' ? false : true" v-model="params.first.digits">
					<div class="plm__button plm__button--plus" @click="addQnt('+', 'first', 'digits')"></div>
				</div>
			</label>

			<!--<label>
				<span>Зеркальные числа: </span>
				<input type="number" min="1" max="8" v-model="first.digits">
			</label>-->
			<div v-if="role !== 'student'">
				<h6 class="l_title l_title--sm">Цифры в первом разряде: </h6>
				<div class="mini_cifers">
					<label v-for="cif in 9" class="mini_cifers" :key="cif.id">
						<input type="checkbox" :value="cif" v-model="params.first.first">
						<span></span>
						<p>{{ cif }}</p>
					</label>
					<div 
						class="mini_cifers__check" 
						@click="selectAllNumbers('first','first')"
						:class="{active: params.first.first.length === 9}"
					></div>
				</div>
				<div v-if="params.first.digits > 1">
					<h6 class="l_title l_title--sm">Цифры в остальных разрядах: </h6>
					<div class="mini_cifers">
						<label v-for="(n, cif) in 10" class="mini_cifers" :key="cif.id">
							<input type="checkbox" :value="cif" v-model="params.first.second">
							<span></span>
							<p>{{ cif }}</p>
						</label>
						<div 
							class="mini_cifers__check" 
							@click="selectAllNumbers('first','second')"
							:class="{active: params.first.second.length === 10}"
						></div>
					</div>
				</div>
				<hr>
			</div>
			<h6 class="l_title">Второй множитель</h6>
			<label>
				<span class="l_title l_title--sm">Количество цифр: </span>
				<div class="plm">
					<div class="plm__button plm__button--minus" @click="addQnt('-', 'second', 'digits')"></div>
					<input type="number" min="3" max="999999" :readonly="role == 'teacher' ? false : true" v-model="params.second.digits">
					<div class="plm__button plm__button--plus" @click="addQnt('+', 'second', 'digits')"></div>
				</div>
			</label>
			<div v-if="role !== 'student'">
				<span class="l_title l_title--sm">Цифры в первом разряде: </span>
				<div class="mini_cifers">
					<label v-for="cif in 9" class="mini_cifers" :key="cif.id">
						<input type="checkbox" :value="cif" v-model="params.second.first">
						<span></span>
						<p>{{ cif }}</p>
					</label>
					<div 
						class="mini_cifers__check" 
						@click="selectAllNumbers('second','first')"
						:class="{active: params.second.first.length === 9}"
					></div>
				</div>
				<div v-if="params.second.digits > 1">
					<span class="l_title l_title--sm">Цифры в остальных разрядах: </span>
					<div class="mini_cifers">
						<label v-for="(n, cif) in 10" class="mini_cifers" :key="cif.id">
							<input type="checkbox" :value="cif" v-model="params.second.second">
							<span></span>
							<p>{{ cif }}</p>
						</label>
						<div 
							class="mini_cifers__check" 
							@click="selectAllNumbers('second','second')"
							:class="{active: params.second.second.length === 10}"
						></div>
					</div>
				</div>
			</div>
		</div>


		<!--- НАСТРОЙКИ ДЕЛЕНИЯ --->
		<div v-else-if="params.type === 'divisi'">
			<hr>
			<label>
				<div class="l_check">
					<input 
						type="checkbox" 
						class="uk-checkbox" 
						v-model="params.hasRemainder"
						@change="params.remainderAnswer = false"
					>
					<span>С дробной частью</span>
				</div>
			</label>
			<label v-if="params.hasRemainder">
				<div class="l_check">
					<input type="checkbox" class="uk-checkbox" v-model="params.remainderAnswer">
					<span>Ответ с остатком</span>
				</div>
			</label>
			<label v-if="params.hasRemainder">
				<span class="l_title l_title--sm">Знаков после запятой</span>
				<Select2 v-model="params.digitsRemainder" :options="[1, 2]" :settings="{multiple: false,minimumResultsForSearch: -1}" />
			</label>
			<hr>
			<h6 class="l_title">Делимое</h6>
			<label>
				<span class="l_title l_title--sm">Количество цифр: </span>
				<div class="plm">
					<div class="plm__button plm__button--minus" @click="addQnt('-', 'first', 'digits')"></div>
					<input type="number" min="3" max="999999" :readonly="role == 'teacher' ? false : true" v-model="params.first.digits">
					<div class="plm__button plm__button--plus" @click="addQnt('+', 'first', 'digits')"></div>
				</div>
			</label>

			<div v-if="role !== 'student'">
				<span class="l_title l_title--sm">Цифры: </span>
				<div class="mini_cifers">
					<label v-for="cif in 9" class="mini_cifers" :key="cif.id">
						<input type="checkbox" :value="cif" v-model="params.first.first">
						<span></span>
						<p>{{ cif }}</p>
					</label>
					<div 
						class="mini_cifers__check" 
						@click="selectAllNumbers('first','first')"
						:class="{active: params.first.first.length === 9}"
					></div>
				</div>
				<hr>
			</div>
			<h6 class="l_title">Делитель</h6>
			<label>
				<span class="l_title l_title--sm">Количество цифр: </span>
				<div class="plm">
					<div class="plm__button plm__button--minus" @click="addQnt('-', 'second', 'digits')"></div>
					<input type="number" min="3" max="999999" :readonly="role == 'teacher' ? false : true" v-model="params.second.digits">
					<div class="plm__button plm__button--plus" @click="addQnt('+', 'second', 'digits')"></div>
				</div>
			</label>
			<div v-if="role !== 'student'">
				<span class="l_title l_title--sm">Цифры: </span>
				<div class="mini_cifers">
					<label v-for="cif in 9" class="mini_cifers" :key="cif.id">
						<input type="checkbox" :value="cif" v-model="params.second.first">
						<span></span>
						<p>{{ cif }}</p>
					</label>
					<div 
						class="mini_cifers__check" 
						@click="selectAllNumbers('second','first')"
						:class="{active: params.second.first.length === 9}"
					></div>
				</div>
			</div>
		</div>

		<div class="razd"></div>
		<label class="check_label">
			<input type="checkbox" class="uk-checkbox" v-model="params.show_reactions">
			<span>Анимации</span>
		</label>

		<div class="modsettings__button" v-if="ingame">
			<button class="uk-button uk-button-primary" @click="apply">Применить</button>
		</div>
	</div>
</template>

<script>
  import Select2 from 'v-select2-component';
  import { mapState } from "vuex";

  export default {
    name: "settings",
    components: { Select2 },
    data() {
      return {
        params: '',
      }
    },
    watch: {
      params: {
        handler: function (newValue) {
          //console.log('Setting changed');
          if (!this.ingame) {
            this.$emit('params_changed', this.params);
          }
        },
        deep: true
      },
      // 'inparams': 'setParams'
    },
    computed: {
      role() {
        return this.$store.state.user.role.code;
      },
      ...mapState({
        item: 'current_trainer'
      })
    },
    props: {
      inparams: '',
      ingame: '',
      is_homework: '',
			autoSettings: ''
    },
    methods: {
      apply() {
        this.$emit('params_changed', this.params);
        this.$parent.setShowsettings();
      },
      setParams() {
        if (this.inparams) {
          //console.log('Has props params');
          this.params = _.cloneDeep(this.inparams);
        } else {
          //console.log('No props params');
					this.params = _.cloneDeep(this.$store.state.train.multi_params);
        }
        this.checkHomework();
      },
      addQnt(val, param, param2) {
        if (!param2) {
          if (val === '+') {
            this.params[param]++;
          } else if (this.params[param] > 1) {
            this.params[param]--;
          }
        } else {
          if (val === '+') {
            this.params[param][param2]++;
          } else if (this.params[param][param2] > 1) {
            this.params[param][param2]--;
          }
        }
      },

			selectAllNumbers(prop1, prop2) {		
				let numbers = Array.from(Array(10).keys());

				if (prop2 === 'first') {
					numbers.splice(0, 1)
				}

				if (this.params[prop1][prop2].length < numbers.length) {
					this.params[prop1][prop2] = numbers
				} else {
					this.params[prop1][prop2] = []
				}
			},
      checkHomework() {
        if (this.is_homework) {
          this.params.users = 1;
          this.params.qnt = 1;
        }
      }
    },
    mounted() {
      this.setParams();
    }
  }
</script>